// GraphQL query execution for Kiddom API
// Wraps the GraphQL endpoint at api.kiddom.co/api/query

import { IQueryInfo } from './mutations'
import { buildQueries } from './queryBuilder'
import { makeKiddomPostRequest } from 'infrastructure/api'

type QueryResponseType<T> = {
  data: Record<string, T>
  error?: string
  errors?: { message: string }[]
}

async function postQuery<T>(
  kiddomPath: string,
  query: string,
  operations: string[],
): Promise<QueryResponseType<T>> {
  const { error, result } = await makeKiddomPostRequest<QueryResponseType<T>>({
    kiddomPath,
    requestBody: {
      query,
      operations,
    },
  })
  if (error) {
    return {
      data: result ?? {},
      error,
    }
  }
  return (
    result ?? {
      data: {},
    }
  )
}

export async function doQueries<T>(
  queryRoute: string,
  queries: IQueryInfo[],
  throwErrors = true,
): Promise<{
  data: Record<string, T>
  errors?: { message: string }[]
  error?: string
}> {
  const query = buildQueries(
    queries.map(({ resourceData: { key, fields }, params, alias }) => ({
      key,
      params,
      fields,
      alias,
    })),
  )
  const operations = queries.map((q) => q.resourceData.key)

  const { data, error, errors } = await postQuery<T>(
    queryRoute,
    query,
    operations,
  )
  if (error && throwErrors) {
    throw new Error(error)
  }

  return {
    data,
    error,
    errors,
  }
}
